import { useState } from 'react'

import { ProductNavTabs } from '@/components/sidebar'
import { Button } from '@/components/ui/button'
import { UserAvatar } from '@/components/ui/user-avatar'
import { ProductFlowNav } from '@/routes/Public/marketing/components/ProductFlowNav'

const TABS = [
  { value: 'insurance', label: 'Insurance' },
  { value: 'bookkeeper', label: 'Bookkeeper' },
]

/** ProductFlowNav's account variant with stand-ins for the app's switcher and menus, which need a signed-in user. */
export function AccountNavDemo() {
  const [tab, setTab] = useState('insurance')
  return (
    <ProductFlowNav
      logoHref={null}
      rightAction={<Button size="sm">View quotes</Button>}
      account={{
        org: <span className="text-ink-900 px-2 text-sm font-medium">Blue Line Freight</span>,
        tabs: <ProductNavTabs tabs={TABS} active={tab} onSelect={setTab} />,
        profile: <UserAvatar name="Jim Mitchell" className="size-7" />,
      }}
    />
  )
}
